<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/as-widget-list"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="components/trip-details-section"></require>

  <div class="holiday-trip-form">
    <as-form-section heading="Basics">
      <div slot="body">
        <div class="form-row">
          <div class="col-md-6">
            <bs-form-input type="text" label="Trip name" placeholder="Give your wonderful trip a unique name" value.bind="model.name & validate" disabled.bind="disabled" hasfocus.bind="autofocus" maxlength="500"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.createdOn">
            <bs-form-input type="text" label="Created by ${model.createdBy.name || model.createdBy.username}" value.bind="model.createdOn | dateTime" disabled="true"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.modifiedOn && !model.archivedOn">
            <bs-form-input type="text" label="Modified by ${model.modifiedBy.name || model.modifiedBy.username}" value.bind="model.modifiedOn | dateTime" disabled="true"></bs-form-input>
          </div>
          <div class="col-md-3" if.bind="model.archivedOn">
            <bs-form-input type="text" label="Archived by ${model.archivedBy.name || model.archivedBy.username}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
          </div>
        </div>
      </div>
    </as-form-section>
    <as-form-section heading="Travellers" intro="Please provide us with information about all bp employees who will take part in this trip. Optionally, you can add information about their travelling friends and relatives.">
      <div slot="body">
        <as-widget-list items.bind="model.travelers & validate" default-kind="holiday-maker" disabled.bind="disabled"></as-widget-list>
      </div>
      <div slot="footer" class="sc-buttons-container" show.bind="!disabled">
        <button type="button" class="btn btn-light" click.delegate="addTraveler()" disabled.bind="disabled">
          <i class="fas fa-user"></i> Add Employee
        </button>
      </div>
    </as-form-section>
    <trip-details-section heading="Trip Details" segments.bind="model.segments & validate" disabled.bind="disabled" intro="Please provide us with more information about this trip. As a minimum, please fill-in the destination city. If you already know the itinerary, you can use the buttons below to add additional details."></trip-details-section>
  </div>
</template>
